import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  createStaticTokenAction,
  getAllStaticTokens,
  updateStaticTokenAction,
} from "./actions";
import type { StaticTokenState } from "./types";

export function getAllStaticTokensReducerBuilder(
  builder: ActionReducerMapBuilder<StaticTokenState>
) {
  builder.addCase(getAllStaticTokens.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getAllStaticTokens.fulfilled, (state, action) => {
    state.tokens = Array.isArray(action.payload) ? action.payload : [];
    state.isLoading = false;
  });
  builder.addCase(getAllStaticTokens.rejected, (state) => {
    state.isLoading = false;
  });
}

export function createStaticTokenReducerBuilder(
  builder: ActionReducerMapBuilder<StaticTokenState>
) {
  builder.addCase(createStaticTokenAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(createStaticTokenAction.fulfilled, (state, action) => {
    state.tokens = [...state.tokens, action.payload];
    state.isLoading = false;
  });
  builder.addCase(createStaticTokenAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function updateStaticTokenReducerBuilder(
  builder: ActionReducerMapBuilder<StaticTokenState>
) {
  builder.addCase(updateStaticTokenAction.fulfilled, (state, action) => {
    state.tokens = state.tokens?.map((token) => {
      if (token.id === action.payload.id) {
        return action.payload;
      }
      return token;
    });
  });
}
